<template>
  <swiper
    class="swiper-container"
    :modules="modules"
    :slides-per-view="1"
    :space-between="50"
    :pagination="{ clickable: true }"
    :autoplay="{ delay: 3000, disableOnInteraction: false }"
    v-if="articles.length"
    @swiper="onSwiper"
    @slideChange="onSlideChange"
  >
    <swiper-slide v-for="article in articles" :key="article.url">
      <p class="title">{{ article.title }}</p>
      <p class="time">{{ article.createtime }}</p>
      <img :src="changeImgUrl(article.img)" :alt="article.title" @click="goToDetail(article)" />
    </swiper-slide>
  </swiper>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, A11y, Autoplay } from "swiper/modules";
import { articleApi } from '@/api/article';
import base64 from 'base-64';

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

export default {
  name: 'SwiperComponent',
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    const router = useRouter();
    const articles = ref([]);
    const loading = ref(false);
    const cacheKey = 'latestArticles'; // 缓存的键

    const fetchLatestArticles = async () => {
      // 检查 localStorage 中是否有缓存数据
      const cachedData = localStorage.getItem(cacheKey);
      if (cachedData) {
        const { data, timestamp } = JSON.parse(cachedData);
        const currentTime = Date.now();
        const cacheDuration = 30 * 60 * 1000; // 设置缓存有效期为 30 分钟

        // 如果缓存数据未过期，则直接使用缓存数据
        if (currentTime - timestamp < cacheDuration) {
          articles.value = data;
          return;
        }
      }

      // 如果没有缓存数据或数据已过期，则发起请求
      if (loading.value) return;
      loading.value = true;
      try {
        const res = await articleApi.getLatestArticles();
        articles.value = res.data;

        // 将请求的数据和当前时间戳存入 localStorage
        localStorage.setItem(cacheKey, JSON.stringify({ data: res.data, timestamp: Date.now() }));
      } catch (error) {
        console.error('获取文章失败:', error);
      } finally {
        loading.value = false;
      }
    };

    onMounted(() => {
      fetchLatestArticles();
    });

    const onSwiper = (swiper) => {
      console.log(swiper);
    };

    const onSlideChange = () => {
      // 处理滑块变化
    };

    const goToDetail = (article) => {
      const page = "https://duud.cn/app/" + article.url;
      const base64Url = base64.encode(page);
      let idx = 3;
      router.push({ name: 'articleDetail', query: { url: base64Url, category: "办事指南", idx: idx } });
    }

    const changeImgUrl = (url)=>{
      return url.replace("https://static.duud.cn/", "https://wq-1258021341.cos.ap-guangzhou.myqcloud.com/");
    }

    return {
      articles,
      onSwiper,
      onSlideChange,
      goToDetail,
      changeImgUrl,
      modules: [Pagination, A11y, Autoplay],
    };
  },
};
</script>

<style scoped>
.swiper-container {
  width: 100%;
  height: 100%;
  border-radius: 20px;
  cursor: pointer;
}
.swiper-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 20px;
}
.swiper-container >>> .swiper-pagination {
  text-align: left !important;
  margin-left: 20px !important;
}
.swiper-container .title {
  position: absolute;
  left: 20px;
  top: 329px;
  width: 760px;
  height: 30px;
  opacity: 1;

  font-family: MiSans;
  font-size: 24px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 纯白 */
  color: #ffffff;

  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
}

.swiper-container .time {
  position: absolute;
  left: 20px;
  top: 379px;
  width: 74px;
  height: 19px;
  opacity: 1;

  font-family: MiSans;
  font-size: 14px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0em;

  font-variation-settings: "opsz" auto;
  font-feature-settings: "kern" on;
  /* 纯白 */
  color: #ffffff;
}
</style>